import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import axios from "axios";
import { use } from "i18next";
import { Settings } from "../../Constant";
import Select from 'react-select';

function Edit(props) {
  document.title = "charger | Edits";
  const [charger, setCharger] = useState(null);
  const params = useParams();
  let ChargerID = params.cid;
  let navigate = useNavigate();
  let location = useLocation();
   let ChargerEditData = location?.state?.ChargerEditData;
   console.log("ChargerEditData", ChargerEditData);

   const fetchData = async () => {
    const apiEndpoint = `${BaseURL}/chargers/edit/${ChargerID}`;
    
    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
          
        }
      });
  console.log("wholeeData", res);
      if (res && res.data && res.data.data && res.data.data.length > 0) {
        setCharger(res.data.data[0]); // Set the first item in the data array
      } else {
        console.error("No charger data found");
      }
    } catch (error) {
      console.error("Error fetching charger data:", error);
    }
  }
  

  useEffect(() => {
    fetchData();
  }, []);
  console.log("chargerData", charger);
  


  // Destructure the data passed from the previous component
  // const UserEditData = location?.state?.UserEditData;

  // Log to ensure StationEditData is availabl

  // State variables
  const [Name, setName] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [loading, setLoading] = useState(false);
  const [VehicleNumber, setVehicleNumber] = useState([]);
  const [selectedParent, setselectedParent] = useState([]);
  const [userType, setUserType] = useState([]);
 
  const [IMEINumber, setIMEINumber] = useState([]);
  const [AmarRajaChargerID, setAmarRajaChargerID] = useState([]);
  const [simNumber, setSimNumber] = useState([]);
  const [ChipID, SetChipID] = useState([]);
  const [BookingAmount, setBookingAmount] = useState([]);
  const [BookingCancelAmount, setBookingCancelAmount] = useState([]);
  const [ChargerEstimatedBidPrice, setChargerEstimatedBidPrice] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);
  const [Tax, setTax] = useState([]);
  const [othercharges, setothercharges] = useState([]);
  const [PerUnitPricewithoutGST, setPerUnitPricewithoutGST] = useState([]);
  const [PerUnitPricewithGST, setPerUnitPricewithGST] = useState([]);
  const [LocalHourse, setLocalHourse] = useState([]);
  const [SecurityCode, setSecurityCode] = useState([]);
  const [ChargerconType, setChargerconType] = useState([]);
  const [ConnectorsType, setConnectorsType] = useState([]);
  const [Power, setPower] = useState([]);
  const [SelectServiceProvider, setSelectServiceProvider] = useState([]);
  const [selectAmenity, setselectAmenity] = useState([]);
  const [SelectVechicle, setSelectVechicle] = useState([]);
  const [PaymentType, setPaymentType] = useState([]);
  const [ChargerType, setChargerType] = useState([]);
  const [Maxvoltage, setMaxvoltage] = useState([]);
  const [Maxcurrent, setMaxcurrent] = useState([]);
  const [MinimumCOneValue, setMinimumCOneValue] = useState([]);
  const [stationName, setStationName] = useState([]);
  const [ChargerData, setChargerData] = useState([]);
  const [PowerListing, setPowerListing] = useState([]);
  const [AmenitiesTypes, setAmenitiesTypes] = useState([]);
  const [Vehiclesnames, setVehiclesnames] = useState([]);
  const [chargingTypesData, setchargingTypesData] = useState([]);
  const [connectorIDList, setConnectorIDList] = useState([]); 
  const [ChargerDataListing, setChargerDataListing] = useState([]);
  const [connectorOptions, setConnectorOptions] = useState([]);
  const [selectedConnectors, setSelectedConnectors] = useState([]);
  const [Imageurl, setImageurl] = useState("");
  const [ChargerMettalicProperty, SetChargerMettalicProperty] = useState([]);
  const [ smartDeviceNumber, setSmartDeviceNumber] = useState("");
  const handleChargerMetallicProperty = (e) => {
    SetChargerMettalicProperty(e.target.value);
  };
  // const [selectedFile, setSelectedFile] = useState(null);

  // Populate form fields with existing data on load


  // Handlers for form fields
  const handleName = (e) => setName(e.target.value);
 
  const handleSelectFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      // Create a URL for the selected file and set it to state
      const imageUrl = URL.createObjectURL(file);
      setImageurl(imageUrl);
      setSelectedFile(file);
    }
  };

  const handleIMEINumberChange = (e) => setIMEINumber(e.target.value);
  const handleAmarRajaPoints = (e) => setAmarRajaChargerID(e.target.value);
  const handleSimNumberChange = (e) => setSimNumber(e.target.value);
  const handleChipNumberChange = (e) => SetChipID(e.target.value);
  const handleBookingAmountChange = (e) => setBookingAmount(e.target.value);
  const handlecancelBookingAmountChange = (e) => setBookingCancelAmount(e.target.value);
  const handleChargerEstimatedBidPriceChange = (e) => setChargerEstimatedBidPrice(e.target.value);
  const handletaxChange = (e) => setTax(e.target.value);
  const handleSmartDeviceNumber = (e) => setSmartDeviceNumber(e.target.value);
  const handleotherchargesChange = (e) => setothercharges(e.target.value);
  const handlePerUnitPricewithoutGSTChange = (e) => setPerUnitPricewithoutGST(e.target.value);
  const handlePerUnitPricewithGSTChange = (e) => setPerUnitPricewithGST(e.target.value);
  const handleLocalHourseChange = (e) => setLocalHourse(e.target.value);
  const handleSecurityCodeChange = (e) => setSecurityCode(e.target.value);
  const handleChargerconTypeChange = (e) => setChargerconType(e.target.value);
  const handleConnectorsTypeChange = (e) => setConnectorsType(e.target.value);
  const handlePowerChange = (e) => setPower(e.target.value);
  const handleServiceProviderChange = (e) => setSelectServiceProvider(e.target.value);
  const handleAmenityChange = (selectedChoices) => {
    const formattedChoices = selectedChoices
      ? selectedChoices.map(option => ({
          _id: option.value,  // Store _id as value
          title: option.label // Store title as label
        }))
      : [];
    setselectAmenity(formattedChoices);
  };
  
  const handleVechicleChange = (e) =>{
    setVehicleNumber(e.target.value)
};
  const handlePaymentTypeChange = (e) => setPaymentType(e.target.value);
  const handleChargerTypeChange = (e) => setChargerType(e.target.value);
  const handleMaxvoltageChange = (e) => setMaxvoltage(e.target.value);
  const handleMaxcurrentChange = (e) => setMaxcurrent(e.target.value);
  const handleMinimumCOneValueChange = (e) => setMinimumCOneValue(e.target.value);
  const handleStationNameChange = (e) => setStationName(e.target.value);
  const handleUserTypeChange = (e) => setUserType(e.target.value);
  const handleStatusType = (e) => setSelectedStatusType(e.target.value);
  // useEffect(() => {
  //   if (charger && charger.charger && charger.charger.select_power_str) {
  //     const selectedPower = charger.charger.select_power_str[0]?._id; // Assuming this is how you get the power ID
  //     if (selectedPower) {
  //       setPower(selectedPower);
  //     }
  //   }
  // }, [charger]);
//station_name
useEffect(() => {
  if (charger) {
    setselectAmenity(charger?.charger?.select_amenity_id.map(id => {
      const amenity = AmenitiesTypes.find(item => item.value === id);
      return amenity ? { _id: amenity.value, title: amenity.label } : {}; // Safely handle cases where amenity is not found
    }) || []);
  }
}, [charger, AmenitiesTypes]); // Adding dependencies to ensure this runs when either changes
useEffect(() => {
  // Only set the default value if VehicleNumber is not already set
  if (charger?.charger?.select_vehicle_id) {
    setVehicleNumber(charger?.charger?.select_vehicle_id[0]);
  }
}, [charger]);


  useEffect(() => {
    if (charger) {
   
    
      setName(charger?.charger?.charger_name);
      setPower(charger?.charger?.select_power_id[0] || []);
      SetChargerMettalicProperty(charger?.charger?.charger_ion_type)

      setSelectedStatusType(charger?.status);
     
      setChargerType(charger?.charger?.master_station_charger_id);
      setChargerconType(charger?.charger?.master_charger_type_id);
      
      setSelectServiceProvider(charger?.charger?.service_provider_str);
     
      
      setIMEINumber(charger?.charger?.imei_number);
      setAmarRajaChargerID(charger?.charger?.AmarRaja_charger_id);
      SetChipID(charger?.charger?.chip_id);
      setSimNumber(charger?.charger?.sim_number);
      setTax(charger?.charger?.tax);
      setSmartDeviceNumber(charger?.charger?.smartDevice?.[0]?.IMEI || '');
      setLocalHourse(charger?.charger?.local_hours);
      setBookingAmount(charger?.charger?.booking_amount);
      setBookingCancelAmount(charger?.charger?.booking_cancel_amount)
      setStationName(charger?.station_name);
      setMaxvoltage(charger?.charger?.max_voltage);
      setMaxcurrent(charger?.charger?.max_current);
      setChargerEstimatedBidPrice(charger?.charger?.charger_estimated_bid_price);
      setPerUnitPricewithGST(charger?.charger?.per_unit_price_with_gst);
      setPerUnitPricewithoutGST(charger?.charger?.per_unit_price_without_gst);
      setSecurityCode(charger?.charger?.security_code);
      setothercharges(charger?.charger?.other_charger);
      setMinimumCOneValue(charger?.charger?.minimum_c_one_value)
 
      setSelectedConnectors(charger?.connectorArr);


   
    }
  }, [charger]);
  console.log("connectorssssss-------",selectedConnectors);

  useEffect(() => {
   
    setImageurl(charger?.imageURL || null);
      
    },
   [charger]);

  const handleConnectorTypeChange = (selectedOptions) => {
    setSelectedConnectors(selectedOptions || []); // Use selectedOptions directly
    console.log('Selected Values:', selectedOptions); // Log the selected values
  };
  const FetchChargerData = async () => {
    setLoading(true);

    try {
      const res = await request({
        url: `${BaseURL}/master/charger-type-0`,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      if (res && res?.data) {

        setChargerData(res?.data);
      } else {
        setChargerData([]); // If no data, ensure filteredData is empty
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setChargerData([]); // In case of error, set filteredData to empty
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchChargerData();
  }, []);




  useEffect(() => {
    // Fetch countries on component mount
    const fetchPowerListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/master/power-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setPowerListing(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchPowerListing();
  }, []);
  useEffect(() => {
    const fetchAmenityListing = async () => {
      try {
       
  
        const response = await axios.get(`${BaseURL}/master/amenites-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
  
        // Assuming the API returns an array of amenities
        const formattedAmenities = response.data.data.map(amenity => ({
          value: amenity._id,  // Assuming _id is the unique identifier for each amenity
          label: amenity.title,  // Assuming name is the display name for each amenity
        }));
        
        setAmenitiesTypes(formattedAmenities);
        // Swal.close();
      } catch (error) {
        console.error("Error fetching amenities:", error);
        Swal.close();
      }
    };
  
    fetchAmenityListing();
  }, []);
  useEffect(() => {
    // Fetch countries on component mount
    const fetchVehicleNamesListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/master/vehicles-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setVehiclesnames(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchVehicleNamesListing();
  }, []);

  const UpdateCharger= async () => {


    // Create a new FormData object
    let formData = new FormData();
    formData.append("charger_name", Name || '');
    // formData.append("status", selectedStatusType);
    formData.append("imei_number", IMEINumber || '');
    formData.append("AmarRaja_charger_id", AmarRajaChargerID || '');
    formData.append("sim_number", simNumber | '');
    formData.append("chip_id", ChipID || '');
    formData.append("booking_amount", BookingAmount || '');
    formData.append("booking_cancel_amount", BookingCancelAmount || '');
    formData.append("charger_estimated_bid_price", ChargerEstimatedBidPrice || '');
    formData.append("tax", Tax || '');
    formData.append("smartDevice[0][IMEI]", smartDeviceNumber || '');
    formData.append("other_charger", othercharges || '');
    formData.append("per_unit_price_without_gst", PerUnitPricewithoutGST || '');
    formData.append("per_unit_price_with_gst", PerUnitPricewithGST || '');
    formData.append("local_hours", LocalHourse || '');
    formData.append("security_code", SecurityCode || '');
    // formData.append("charger_conn_type", ChargerconType);\\
    formData.append("max_voltage", Maxvoltage || '');
    formData.append("max_current", Maxcurrent || '');
    formData.append("minimum_c_one_value", MinimumCOneValue || '');
    if (selectAmenity.length > 0) {
      selectAmenity.forEach(amenity => {
        formData.append("select_amenity_id[]", amenity._id); // Append each _id separately
      });
    }
    
    if (Power.length >0 ) {
    formData.append("select_power_id", Power || []);
    }
    // formData.append("payment_type_id", "1234");
    formData.append("master_charger_type_id",ChargerconType)  ;
    if(VehicleNumber) {
    formData.append("select_vehicle_id", VehicleNumber);
    }
    formData.append("master_station_charger_id", ChargerType);
    if (selectedFile) {
      formData.append("charger_image", selectedFile);
    }
    
    if(ChargerMettalicProperty) {
      formData.append("charger_ion_type", ChargerMettalicProperty );
    }
if(selectedConnectors) {
    for (var i = 0; i < selectedConnectors.length; i++) {
      formData.append(`connectors[${i}][master_connector_id]`, selectedConnectors[i]?.value);
    }
  };
   


    try {
      // Make the API request    try {
      Swal.fire({
        title: 'Processing...',
        text: 'please wait...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      let response = await axios.put(
        `${BaseURL}/chargers/edit/${ChargerID}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
            // 'Content-Type' is automatically set by axios when using FormData
          },
        }
      );

      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response?.data?.message,
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/chargers`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to update station. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      console.error("Error in EditCharger:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };

  const handleConnectorIDChange = async (e) => {
    const selectedConnectionType = e.target.value || ChargerconType;
    setChargerconType(selectedConnectionType);
  }

  useEffect(() => {
    const fetchConnectorOptions = async () => {
      if (ChargerconType) {
        try {
          const response = await axios.get(
            `${BaseURL}/master/?parent_id=${ChargerconType}`,
            {
              headers: {
                Authorization: `Bearer ${uniqueToken}`,
              },
            }
          );

          const fetchedConnectorOptions = response.data.data.map((connector) => ({
            value: connector._id,
            label: connector.title,
          }));

          setConnectorOptions(fetchedConnectorOptions);
          setConnectorIDList(response.data.data);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    };

    fetchConnectorOptions();
  }, [ChargerconType]);
  useEffect(() => {
    const ChargingTypesData = async () => {
      setLoading(true);
      const apiEndpoint = `${BaseURL}/master/station_charger-0`;
      try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("ocpps response", response);
        setChargerDataListing(response?.data?.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      } finally {
        setLoading(false);
      }
    };

    ChargingTypesData();
  }, []);
  const selectedConnectorIDs = [];
  console.log("power", Power);
  console.log("Amenity.....", selectAmenity);
  console.log("vehicleNumber......", VehicleNumber);
  console.log("chargerconnnnnnntype.....", ChargerconType);

  return (
    <>
      <div className="container-fluid">
      {loading ? (
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    ) : (
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Edit Chargers
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="name_id" className="col-sm-2 control-label">
                              Charger Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleName}
                                value={Name}
                                className="form-control"
                                id="name_id"
                                name="station_name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                      

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              IMEI Number
                            </label>
                            <div className="col-sm-6">
                              <input
                                id="state"
                                className="form-control"
                                  value={IMEINumber}
                                onChange={handleIMEINumberChange}

                              >

                              </input>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              AmarRaja Charger ID
                            </label>
                            <div className="col-sm-6">
                              <input
                                id="city"
                                className="form-control"
                                value={AmarRajaChargerID}
                                onChange={handleAmarRajaPoints}

                              />


                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Sim Numnber
                            </label>
                            <div className="col-sm-6">
                              <input
                                type="text"
                                onChange={handleSimNumberChange}
                                value={simNumber}
                                className="form-control"
                                id="VehicleNumber"
                                name="VehicleNumber"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Chip ID
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleChipNumberChange}
                                value={ChipID}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Booking Amount
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleBookingAmountChange}
                                value={BookingAmount}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Charger Metallic Property
                            </label>
                            <div className="col-sm-6">
                              <select
                              value={ChargerMettalicProperty}
                                onChange={handleChargerMetallicProperty}

                                className="form-control"
                                id="address_id"
                                name="address"
                              >
                                <option value=" ">Select Property</option>
                                <option value="li-ion">Lithium Ion</option>
                                <option value="lead-acid">Lead Acid</option>
                                </select>

                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Booking Cancel Amount
                            </label>
                            <div className="col-sm-6">
                              <input
                              value={BookingCancelAmount}
                                onChange={handlecancelBookingAmountChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Charger Estimated Bid Price
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleChargerEstimatedBidPriceChange}
                                 value={ChargerEstimatedBidPrice}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Tax
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handletaxChange}
                                value={Tax}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Other Charges
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleotherchargesChange}
                                value={othercharges}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Per Unit Price without GST
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlePerUnitPricewithoutGSTChange}
                                 value={PerUnitPricewithoutGST}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Per Unit Price with GST
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlePerUnitPricewithGSTChange}
                                value={PerUnitPricewithGST}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Local Hourse
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleLocalHourseChange}
                                 value={LocalHourse}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Security Code
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleSecurityCodeChange}
                                value={SecurityCode}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Charger Type
                            </label>
                            <div className="col-sm-6">
                            <select
                                type="text"
                                className="form-control"
                                id="additionalInput2"
                                name="additionalInput2"
                                value={ChargerType}
                                onChange={handleChargerTypeChange}
                              >
                                <option value="0">Select Charger Type</option>
                                {ChargerDataListing?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Charger Conn Type
                            </label>
                            <div className="col-sm-6">
                              <select
                                type="text"
                                className="form-control"
                                value={ChargerconType}
                                id="additionalInput2"
                                name="additionalInput2"
                                onChange={handleConnectorIDChange}
                              >
                                <option value="0">Select Connection Type</option>
                                {ChargerData?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>


                                  );
                                })}
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
  <div className="row">
    <label htmlFor="connectors_type" className="col-sm-2 control-label">
      Connectors Type
    </label>
    <div className="col-sm-6">
    <Select
          options={connectorOptions} // The options fetched dynamically based on parent_id
          isMulti
          onChange={handleConnectorTypeChange}
          value={selectedConnectors}
          placeholder="Select Connectors Type"
        />
    </div>
    <span className="col-sm-4 control-label"></span>
  </div>
</div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Select Power
                            </label>
                            <div className="col-sm-6">
                            <select
  onChange={handlePowerChange}
  value={Power} // Make sure this matches the _id of an option
  className="form-control"
  id="power_id" // Change to a meaningful ID
  name="power"
>
  <option value="">Select Power</option> {/* Using an empty string to indicate no selection */}
  {PowerListing?.map((item) => (
    <option key={item?._id} value={item?._id}>
      {item?.title}
    </option>
  ))}
</select>

                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Select Service Provider
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleServiceProviderChange}
                                   value={SelectServiceProvider}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Select Amenity
                            </label>
                            <div className="col-sm-6">
                            <Select
  isMulti
  options={AmenitiesTypes}
  onChange={handleAmenityChange}
  className="basic-multi-select"
  classNamePrefix="select"
  placeholder="Select Amenity"
  value={selectAmenity
    .filter(amenity => amenity && amenity._id) // Filter out any falsy values
    .map(amenity => ({ value: amenity._id, label: amenity.title }))}
/>


                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Select Vehicle
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleVechicleChange}
                                 value={VehicleNumber}
                                className="form-control"
                                id="address_id"
                                name="address"
                              >
                                <option value="0">Select Vehicle</option>
                                {Vehiclesnames?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                         <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Max Voltage
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMaxvoltageChange}
                          value={Maxvoltage}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Max Current
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMaxcurrentChange}
                  value={Maxcurrent}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Minimum C One Value
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMinimumCOneValueChange}
                                value={MinimumCOneValue}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                  

                        <div className="form-group">
                        <div className="row">
                          <label htmlFor="profile_image" className="col-sm-2 control-label">Profile Image</label>
                          <div className="col-sm-6">
                            <input type="file" onChange={handleSelectFileChange} className="form-control" id="profile_image" />
                          </div>
                          <div className="col-sm-4 control-label">
            {/* Show image preview if an existing image URL is available */}
            {Imageurl && typeof Imageurl === 'string' && (
              <img
                src={Imageurl} // Use the image URL for src
                alt="Current Category"
                style={{ width: '100px', height: '100px', objectFit: 'cover', marginLeft: "180px" }}
              />
            )}

          
          </div>
                        </div>
                      </div>

                      <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Smart Device Number
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleSmartDeviceNumber}
                                value={smartDeviceNumber}
                                className="form-control"
                                id="smart_device_id"
                                name="smart_device_id"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={UpdateCharger}
                              value="Update Charger"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         )}
      </div>
    </>
  );
}

export default Edit;
